<div class="roles-page">

  <!-- ── Page header ─────────────────────────────────────── -->
  <app-page-header
    section="Administration"
    pageTitle="Roles & Permissions"
    [badgeText]="totalResults + ' roles'"
    subtitle="Manage platform access and permission structures"
    [actions]="headerActions"
    (actionClick)="onHeaderAction($event)">
  </app-page-header>

  <app-page-toolbar
    searchPlaceholder="Search by role name..."
    [filters]="filters"
    [rightText]="roleRows.length + ' / ' + totalResults + ' roles'"
    (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)">
  </app-page-toolbar>

  <app-data-table
    [columns]="roleColumns"
    [rows]="roleRows"
    [totalResults]="totalResults"
    [currentPage]="currentPage"
    [itemsPerPage]="itemsPerPage"
    [showCheckboxes]="false"
    [showPagination]="true"
    [resultsLabel]="'roles'"
    [avatarType]="'icon'"
    [iconUrl]="'assets/icons/shield-2.svg'"
    [serverSidePagination]="true"
    (pageChange)="onPageChange($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
    (rowClick)="onRowClick($event)">
  </app-data-table>

</div>
